import { getCookie, setCookie } from 'cookick';
import type { UrlWithParsedQuery } from 'url';
import URL from 'utils/URL';

// SETTINGS为官网全局的环境变量对象
export const query: any = { ...URL.current().query };

type StorageType = 'cookie' | 'session';
type QueryValueType = string | string[];

/**
 * @description 获取query中对应的key的值, 如果对应的是值是数组, 则取第一个元素, 否则返回该值
 * @param key 对应的query的key
 * @param latest 如果为true, 则从当前最新的url中获取query; 否则取进入项目时的query
 */
function getQueryValue(keys: string, latest?: boolean): string;
function getQueryValue(keys: string[], latest?: boolean): string[];
function getQueryValue(keys: QueryValueType, latest?: boolean): QueryValueType {
    const curQuery: UrlWithParsedQuery['query'] = latest ? URL.current().query : query;

    const getFirstItem = (data: QueryValueType) => {
        return Array.isArray(data) ? data[0] : data;
    };

    if (typeof keys === 'string') {
        return getFirstItem(curQuery[keys]!);
    }

    return keys.map(t => getFirstItem(curQuery[t]!));
}

export { getQueryValue };

export function getStorageOrUrlValue<T = string>(key, from: StorageType = 'cookie', latest?: boolean): T {
    let storage: any;

    try {
        storage =
            getQueryValue(key, latest) || (from === 'cookie' ? getCookie(key) : sessionStorage.getItem(key)) || '';
    } catch {}

    return storage;
}

export function saveStorageValue(key, value, to: StorageType = 'cookie') {
    if (to === 'cookie') {
        setCookie(key, value, {
            path: '/',
            maxAge: 3600 * 24 * 0.5
        });
    } else {
        sessionStorage.setItem(key, value);
    }
}

export function clearStorage(key: string, type: 'local' | 'session' = 'session') {
    try {
        window[`${type}Storage`].removeItem(key);
    } catch {}
}
